// Orquestador de carga de escenas del parque (NÚCLEO ESTABLE).
//
// No conoce el motor de render ni Vue. Su única responsabilidad es controlar la
// CONCURRENCIA de la carga: recibe por inyección CÓMO descargar y CÓMO procesar
// cada parte, y garantiza como máximo `concurrency` descargas en vuelo.
//
// La política de "qué/cuándo cargar" (hoy: todas las partes del parque vía JSON;
// mañana: por vista / binario / bajo demanda) se decide con los callbacks y los
// argumentos, SIN tocar este orquestador. Es el punto donde el loader binario se
// enchufará en fases siguientes (mismo contrato, distinta implementación de
// `download`/`process`).
//
// Contrato de los callbacks:
//   download(part) -> Promise<payload|null>   // SOLO red; se paraleliza.
//   process(part, payload) -> void            // SÍNCRONO; puede tocar un motor
//                                             // compartido sin intercalarse.

export function createSceneLoader({ download, process, concurrency = 6 }) {
  if (typeof download !== 'function' || typeof process !== 'function') {
    throw new Error('createSceneLoader: se requieren callbacks download y process')
  }

  /**
   * Carga una lista de partes con un pool de `concurrency` workers que consumen
   * una cola compartida. La descarga (lenta, es esperar al servidor) corre en
   * paralelo; el proceso es SÍNCRONO dentro del worker (sin await en medio), así
   * no se pisan el estado entre partes cuando comparten un motor.
   *
   * @param {Array} parts
   */
  async function loadParts(parts) {
    const queue = (parts || []).slice()

    const worker = async () => {
      while (queue.length) {
        const part = queue.shift()
        if (!part) continue

        const payload = await download(part) // paralelo: NO toca el motor
        if (!payload) continue

        process(part, payload) // síncrono: seguro con el motor compartido
      }
    }

    const n = Math.min(concurrency, queue.length)
    await Promise.all(Array.from({ length: n }, () => worker()))
  }

  return { loadParts }
}
